const parseJson = (response) =>
  response.json().then((data) => {
    if (!response.ok) {
      throw Object.assign(new Error(data.error || 'Request failed'), { status: response.status, data });
    }
    return data;
  });

export const getClientContactConsent = (token) =>
  fetch(`/api/v2/client_contact_consents/${encodeURIComponent(token)}`, {
    headers: { 'Content-Type': 'application/json' },
  }).then(parseJson);

export const submitClientContactConsent = (token, response) =>
  fetch(`/api/v2/client_contact_consents/${encodeURIComponent(token)}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ response }),
  }).then(parseJson);
